var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 180.85,
    height: 31.971,
    viewBox: "0 0 180.85 31.971",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Haydon_Logotype_CMYK_White",
    transform: "translate(-75.8 -125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M76.418,158.1l-.618-.618V127.518l.618-.618h6.309l.618.618v17.755H96.475V127.518l.618-.618H103.4l.618.618v29.968l-.618.618H97.093l-.618-.618V145.955H83.345v11.531l-.618.618H76.418Z",
    transform: "translate(0 -1.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M353.076,126.9h7.652l6.1,11.637,6.1-11.637h7.609l.618.618-10.529,16.625v13.343l-.661.618H363.69l-.618-.618V144.143L352.5,127.518Z",
    transform: "translate(-217.724 -1.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M514.9,158.1H501.518l-.618-.618V127.518l.618-.618H514.9c8.632,0,13.811,6.565,13.811,15.6,0,9.058-5.243,15.6-13.811,15.6Zm-6.458-5.925H511.6c5.243,0,9.549-2.771,9.549-9.677s-4.5-9.677-9.549-9.677h-3.154v19.353Z",
    transform: "translate(-334.494 -1.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M643.9,141.007c0-9.186,5.243-16.007,14.749-16.007s14.749,6.778,14.749,16.007-5.286,15.964-14.749,15.964S643.9,150.151,643.9,141.007Zm14.771,10.039c4.305,0,7.2-3.3,7.2-10.039s-2.707-10.082-7.2-10.082-7.2,3.432-7.2,10.082S654.173,151.046,658.671,151.046Z",
    transform: "translate(-447.015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M819.079,157.486l-12.234-26.174v26.174l-.618.618h-6.266l-.661-.618V127.518l.661-.618h5.286l.661.618,12.49,26.536V127.518l.618-.618h6.309l.618.618v29.968l-.618.618H819.7l-.618-.618Z",
    transform: "translate(-569.293 -1.495)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M234.862,145.273l3.41-9.016h0l3.453,9.016Zm-.256.682-4.348,11.531-.618.618h-6.522l-.618-.618,12.469-30.1.7-.49h5.286l.7.49,12.49,30.1-.618.618h-6.522l-.618-.618-4.412-11.531h-7.375Z",
    transform: "translate(-115.432 -1.495)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLight);
export default __webpack_public_path__ + "static/media/logo-light.5c703b46c096d13cc0c5c2e3070b227e.svg";
export { ForwardRef as ReactComponent };